/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CityViewModel } from "../types/CityViewModel.ts";

export const cityViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  code: z.string().nullish(),
  name: z.string().nullish(),
  stateId: z.optional(z.number().int()),
  stateName: z.string().nullish(),
  countryId: z.optional(z.number().int()),
  countryName: z.string().nullish(),
  population: z.optional(z.number().int()),
}) as unknown as ToZod<CityViewModel>;
